/** Zpracované props na základě datového typu. */
export type DataTypeSpecificProps = {
    displayFormat: string | undefined;
    isBigNumber: boolean;
    isWholeNumber: boolean;
    minValue: number | undefined;
    maxValue: number | undefined;
};
